//import { authHeader } from '../_helpers';
//import config from 'react-global-configuration';



export const dataService = {
    getInvoices,
    getZCreditTransaction,
    getPrePaidCounters,
    getMeterBalance,
    directDebitBranches,
    directDebitList,
    directDebitBranchesSave
};

function directDebitBranchesSave(token, card_id, allBranches) {
    let branches = allBranches.filter(function(branch) {
        return branch["dirty"] === 'Y';
      });
    
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify({ token, card_id, branches })
    };
   
    return fetch(`${process.env.REACT_APP_REST_URL}/payments/directDebitBranches`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return ({ "message": "branches_updated_with_dd", branches_count: data.length })  ;
        })
        .catch((error) => {
            console.error('Error:', error);
            return ({ 'error': true, "message": error.toString() });
        });
}
function directDebitBranches(token, card_id) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify({ token, card_id })
    };
   
    return fetch(`${process.env.REACT_APP_REST_URL}/payments/directDebitBranches`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
            return ({ 'error': true, "message": error.toString() });
        });
}

function directDebitList(token, card_id) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify({ token, card_id })
    };
   
    return fetch(`${process.env.REACT_APP_REST_URL}/payments/directDebitList`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
            return ({ 'error': true, "message": error.toString() });
        });
}

function getMeterBalance(token, serial_no, seq) {    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify({token, serial_no, seq })
    };


    console.log(process.env.REACT_APP_REST_URL);
    return fetch(`${process.env.REACT_APP_REST_URL}/counters/meterBalance`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
            return ({ 'error': true, "message": error.toString() });
        });
}

function getPrePaidCounters(card_id, token) {    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify({ card_id, token })
    };


    console.log(process.env.REACT_APP_REST_URL);
    return fetch(`${process.env.REACT_APP_REST_URL}/counters/prepaid`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
            return ({ 'error': true, "message": error.toString() });
        });
}

function getInvoices(card_id, inv_status, token) {
    //let token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjYXJkX2lkIjoiODI5MjEwNDMxIiwiaWF0IjoxNTc4NjU3MDk0LCJleHAiOjE1Nzg3NDM0OTR9.wHeFdBTZvYnn2HzTlJQqYzd3K5VArFf1Q_ww640lzlQ";
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify({ card_id, inv_status, token })
    };


    console.log(process.env.REACT_APP_REST_URL);
    return fetch(`${process.env.REACT_APP_REST_URL}/invoices`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
            return ({ 'error': true, "message": error.toString() });
        });

}

function getZCreditTransaction(UniqueID, token) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify({ UniqueID, token })
    };

    return fetch(`${process.env.REACT_APP_REST_URL}/payments/zCreditTransaction`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        }).catch((error) => {
            console.error('Error:', error);
            return ({ 'error': true, "message": error.toString() });
        });

}

function handleResponse(response) {
    return response.text().then(text => {
        if (response.ok) {
            const data = text && JSON.parse(text);
            console.log(data);
            return data;
        } else {
            console.log(`-------- ${text} --------`);
            return Promise.reject(response.statusText);
        }
    });
}